<template>
    <div>
        <a-tabs defaultActiveKey="1" @change="callback" size="large">
            <a-tab-pane tab="Trucks" key="1">
                <trucks></trucks>
            </a-tab-pane>
            <a-tab-pane tab="Truck Maps" key="2">
                <truck-maps></truck-maps>
            </a-tab-pane>
<!--            <a-tab-pane tab="Truck Map" key="3">-->
<!--                <truck-map title="5ba387335af3682a5a50eb03" truck-id="5ba387335af3682a5a50eb03"></truck-map>-->
<!--            </a-tab-pane>-->
        </a-tabs>
    </div>
</template>

<script>
    import Trucks from '../../components/tables/TrucksCarrier';
    import TruckMaps from '../../components/tables/TruckMapsCarrier';
    import TruckMap from '../../components/cards/TruckMapCard';

    export default {
        // Do not forget this little guy
        name: 'truck-metrics',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: {
            bar: {}, // Alphabetized
            foo: {},
            fooBar: {},
        },
        // variables
        data() {
            return {

            }
        },
        computed: {},
        // when component uses other components
        components: {
            Trucks,
            TruckMaps,
            TruckMap,
        },
        // methods
        watch: {},
        methods: {
            callback (key) {
                console.log(key)
            },
        },
        // component Lifecycle hooks
        beforeCreate() {
        },
        mounted() {
        },
    };
</script>

<style scoped>

</style>